
function init() {
  const $readMore = jQuery('[data-read-more]');
  if (!$readMore) return
  initReadMore($readMore);
}

function initReadMore($readMore) {
  const readMoreContainer = $readMore.data('read-more');
  const $readMoreContainer = jQuery('#' + readMoreContainer);

  $readMore.bind('click', function (event) {
    event.preventDefault();
    $readMoreContainer.addClass('unfolded');
  });
}

export default { init }









